import styled from "styled-components";
import { FormSelect } from "shards-react";
export const SelectWrapper = styled(FormSelect)`
    padding: 8px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 90%;
    margin: 12px;
    outline: none;
    background-color: #fff;
    /* Personalizar a scrollbar */
    scrollbar-width: thin;
    scrollbar-color: #365648 #f4f4f4;

    ::-webkit-scrollbar {
        width: 8px;
    }

    ::-webkit-scrollbar-track {
        background-color: #f4f4f4;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #365648;
        border-radius: 4px;
    }
`;

export const SelectOption = styled.option`
    background-color: #fff;
    font-size: 16px;
    padding: 8px;
    border: 1px solid red !important;
`;

export const TextOnlyOrganization = styled.div`
    padding: 10px;
    font-size: 14px;
    border-radius: 4px;
    margin: 12px;
    outline: none;
    background-color: #f4f4f4;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;
